import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import {RootState} from '~/redux/root-reducer';
import NotFoundPage from '~/pages/not-found';
import {HAIR_LOSS_TELECONSULTATION_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/hair-loss-teleconsultation/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/hair-loss-teleconsultation/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/hair-loss-teleconsultation/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/hair-loss-teleconsultation/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/hair-loss-teleconsultation/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/hair-loss-teleconsultation/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/hair-loss-teleconsultation/Questionnaire7Screen';
import Questionnaire8Screen from '~/pages/homes/hair-loss-teleconsultation/Questionnaire8Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const HairLossTeleconsultation = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case HAIR_LOSS_TELECONSULTATION_KEYS.START:
        trackPageViewGA('/hair-loss-tel/start', 'MDQ-Hair Loss Tel - Start');
        return <Questionnaire1Screen />;
      case HAIR_LOSS_TELECONSULTATION_KEYS.PROFILE:
        trackPageViewGA('/hair-loss-tel/profile', 'MDQ-Hair Loss Tel - Profile');
        return <Questionnaire2Screen />;
      case HAIR_LOSS_TELECONSULTATION_KEYS.INVALID:
        trackPageViewGA('/hair-loss-tel/invalid', 'MDQ-Hair Loss Tel - Invalid');
        return <Questionnaire3Screen />;
      case HAIR_LOSS_TELECONSULTATION_KEYS.LOOKING_FOR_HELP:
        trackPageViewGA('/hair-loss-tel/looking-for-help', 'MDQ-Hair Loss Tel - Looking For Help');
        return <Questionnaire4Screen />;
      case HAIR_LOSS_TELECONSULTATION_KEYS.SELECT_SYMPTOMS:
        trackPageViewGA('/hair-loss-tel/select-symptoms', 'MDQ-Hair Loss Tel - Select Symptoms');
        return <Questionnaire5Screen />;
      case HAIR_LOSS_TELECONSULTATION_KEYS.IMPORTANT_TREATING_HAIR_LOSS:
        trackPageViewGA(
          '/hair-loss-tel/important-treating-hair-loss',
          'MDQ-Hair Loss Tel - Important Treating Hair Loss',
        );
        return <Questionnaire6Screen />;
      case HAIR_LOSS_TELECONSULTATION_KEYS.HAIR_LOSS_MEDICATION_OR_TREATMENT:
        trackPageViewGA(
          '/hair-loss-tel/hair-loss-medication-or-treatment',
          'MDQ-Hair Loss Tel - Hair Loss Medication Or Treatment',
        );
        return <Questionnaire7Screen />;
      case HAIR_LOSS_TELECONSULTATION_KEYS.OTHER_CONDITION_OR_MEDICAL_HISTORY:
        trackPageViewGA(
          '/hair-loss-tel/other-condition-or-medical-history',
          'MDQ-Hair Loss Tel - Other Condition Or Medical History',
        );
        return <Questionnaire8Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <NotFoundPage />;
    }
  };

  return renderQuestion();
};

export default HairLossTeleconsultation;
